var $2b516a43c48d9ac5$exports = {};
$2b516a43c48d9ac5$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Farbw\xe4hler`,
    "colorSwatch": `Farbfeld`,
    "transparent": `transparent`,
    "twoDimensionalSlider": `2D-Schieberegler`
};


export {$2b516a43c48d9ac5$exports as default};
//# sourceMappingURL=de-DE.mjs.map
